<div class="modal-content">

  <div class="modal-header p-1 mb-1">
    <h6 class="modal-title" id="modal-text-orange">Mention Amount</h6>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body p-2 mb-2">
    <div class="row">  
      <div class="col-md-12 col-lg-6 mb-4 align-items-stretch ">
        <div class="form-group">
          <label for="payAmount" class="text-gray-bold">Amount To Pay</label>
          <input type="text" class="form-control rounded-0" [(ngModel)]="payAmount" id="payAmount" placeholder="amount">             
        </div>
      </div>
    </div>  
  </div>

  <div class="modal-footer p-1 mb-1">
    <button type="button" class="btn-custom p-1" (click)="confirm()">Confirm</button>
    <button type="button" class="btn-custom p-1" (click)="cancel()">Cancel</button>
  </div>

</div><!--modal-content ends-->
  